import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";

export default function Navbar() {
    const { user, logout } = useAuth();
    const loc = useLocation();
    const isDash = loc.pathname.startsWith("/dashboard") || loc.pathname.startsWith("/admin");

    return (
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-zinc-200">
            <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
                    <Logo />
                </Link>
                <nav className="hidden md:flex items-center gap-8 text-sm">
                    {!isDash && (
                        <>
                            <a href="/#features" className="text-zinc-700 hover:text-fzblue">Fonctionnalités</a>
                            <a href="/#ai" className="text-zinc-700 hover:text-fzblue">Intelligence IA</a>
                            <a href="/#health" className="text-zinc-700 hover:text-fzblue">Santé & Hygiène</a>
                            <Link to="/pricing" className="text-zinc-700 hover:text-fzblue">Tarifs</Link>
                        </>
                    )}
                </nav>
                <div className="flex items-center gap-3">
                    {user && user.role === "admin" && (
                        <Link data-testid="nav-admin" to="/admin" className="hidden md:inline btn-ghost">Admin</Link>
                    )}
                    {user ? (
                        <>
                            <Link data-testid="nav-dashboard" to="/dashboard" className="btn-outline hidden sm:inline-flex">Mon frigo</Link>
                            <button data-testid="nav-logout" onClick={logout} className="btn-ghost">Déconnexion</button>
                        </>
                    ) : (
                        <>
                            <Link data-testid="nav-login" to="/login" className="btn-ghost">Connexion</Link>
                            <Link data-testid="nav-register" to="/register" className="btn-primary">Commencer</Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
